<span
  #container
  [ngClass]="[
    'p-calendar',
    showIcon ? 'p-calendar-w-btn' : '',
    timeOnly ? 'p-calendar-timeonly' : '',
    styleClass || '',
  ]"
  [ngStyle]="style">
  @if (!inline) {
    @if (isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
      <label
        iu-apiz-label
        [fontSize]="overridedCSS?.labelFontSize"
        [for]="inputId"
        [isFieldOnly]="isFieldOnly"
        [label]="label">
        {{ label }}
      </label>
    }
    <div class="calendar-input-container">
      <input
        #inputfield
        autocomplete="off"
        data-cy="input-text"
        tabindex="-1"
        type="text"
        [attr.data-cy-columnName]="columnName"
        [attr.id]="inputId"
        [attr.name]="name"
        [attr.required]="required"
        [attr.tabindex]="tabindex"
        [attr.value]="inputFieldValue"
        [disabled]="readonlyInput"
        [ngClass]="['p-inputtext ui-corner-all', mandatoryCss || '', inputStyleClass || '']"
        [ngStyle]="inputStyle"
        [placeholder]="placeholder || ''"
        [readonly]="readonlyInput"
        [style.width]="'calc(100% - ' + (hasTodayBtn && !timeOnly ? 26 : 0) + 'px - ' + (showIcon ? 26 : 0) + 'px)'"
        [tabindex]="readonlyInput ? '-1' : null"
        (blur)="onInputBlur($event)"
        (change)="onInputBlur($event)"
        (click)="onInputClick()"
        (focus)="!readonlyInput ? onInputFocus($event) : null"
        (input)="onUserInput($any($event))"
        (keydown)="onInputKeydown($event)"
        (mousedown)="cancelFocus($event)" />
      @if (hasTodayBtn && !timeOnly) {
        <i
          aria-hidden="true"
          data-cy="today-mode"
          disabled="readonlyInput"
          tabindex="-1"
          type="button"
          [attr.data-cy-today-mode]="calendarConfig.todayMode ? 'on' : 'off'"
          [ngClass]="[
            disabled ? 'p-disabled' : '',
            calendarConfig.todayMode ? 'icon-today-full' : 'icon-today',
            'iconeCalendar',
          ]"
          (click)="!readonlyInput && onTodayModeChange(!calendarConfig.todayMode)"></i>
      }
      @if (showIcon) {
        <i
          aria-hidden="true"
          disabled="readonlyInput"
          tabindex="-1"
          type="button"
          [ngClass]="[
            timeOnly ? 'icon-hours' : 'icon-calendar',
            disabled || calendarConfig.todayMode ? 'p-disabled' : '',
            'iconeCalendar p-datepicker-trigger',
          ]"
          (click)="!readonlyInput && onButtonClick($event, inputfield)"></i>
      }
    </div>
  }

  @if ((inline || overlayVisible) && calendarConfig.todayMode) {
    <div
      style="top: 48px"
      [@.disabled]="inline === true"
      [@overlayAnimationCalendar]="
        touchUI
          ? {
              value: 'visibleTouchUI',
              params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions },
            }
          : {
              value: 'visible',
              params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions },
            }
      "
      [ngClass]="[
        'p-datepicker ui-corner-all',
        inline ? 'p-datepicker-inline' : 'ui-shadow',
        disabled ? 'p-disabled' : '',
        timeOnly ? 'p-datepicker-timeonly' : '',
        this.numberOfMonths > 1 ? 'p-datepicker-multiple-month' : '',
        currentView === 'month' ? 'p-datepicker-monthpicker' : '',
        touchUI ? 'p-datepicker-touch-ui' : '',
        panelStyleClass || '',
      ]"
      [ngStyle]="panelStyle"
      (click)="$event.stopPropagation()"
      (@overlayAnimationCalendar.done)="onOverlayAnimationDone($event)"
      (@overlayAnimationCalendar.start)="onOverlayAnimationStart($event)">
      <ng-container
        [ngTemplateOutlet]="todayModeSuggestionsTpl"
        [ngTemplateOutletContext]="{ $implicit: todayModeSuggestions }" />
    </div>
  }
  @if ((inline || overlayVisible) && !calendarConfig.todayMode) {
    <div
      style="top: 48px"
      [@.disabled]="inline === true"
      [@overlayAnimationCalendar]="
        touchUI
          ? {
              value: 'visibleTouchUI',
              params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions },
            }
          : {
              value: 'visible',
              params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions },
            }
      "
      [ngClass]="[
        'p-datepicker ui-corner-all',
        inline ? 'p-datepicker-inline' : 'ui-shadow',
        disabled ? 'p-disabled' : '',
        timeOnly ? 'p-datepicker-timeonly' : '',
        this.numberOfMonths > 1 ? 'p-datepicker-multiple-month' : '',
        currentView === 'month' ? 'p-datepicker-monthpicker' : '',
        touchUI ? 'p-datepicker-touch-ui' : '',
        panelStyleClass || '',
      ]"
      [ngStyle]="panelStyle"
      (click)="$event.stopPropagation()"
      (@overlayAnimationCalendar.done)="onOverlayAnimationDone($event)"
      (@overlayAnimationCalendar.start)="onOverlayAnimationStart($event)">
      @if (!timeOnly) {
        @for (month of months; track i; let i = $index) {
          <div class="p-datepicker-group">
            <div class="p-datepicker-header ui-corner-all">
              <ng-content select="p-header" />
              @if (i === 0) {
                <a
                  class="p-datepicker-prev ui-corner-all"
                  href="#"
                  tabindex="-1"
                  (click)="$event.preventDefault(); navBackward($event)">
                  <span class="pi pi-chevron-left"></span>
                </a>
              }
              @if (numberOfMonths === 1 ? true : i === numberOfMonths - 1) {
                <a
                  class="p-datepicker-next ui-corner-all"
                  href="#"
                  tabindex="-1"
                  (click)="$event.preventDefault(); navForward($event)">
                  <span class="pi pi-chevron-right"></span>
                </a>
              }
              <div class="p-datepicker-title">
                @if (!monthNavigator && currentView !== 'month') {
                  <span class="p-datepicker-month" (click)="switchToMonthView($event)">{{ locale.monthNames[month.month] }}</span>
                }
                @if (monthNavigator && currentView !== 'month' && numberOfMonths === 1) {
                  <select
                    class="p-datepicker-month"
                    tabindex="-1"
                    (change)="onMonthDropdownChange($any($event).target.value)"
                    (click)="$event.stopPropagation()">
                    @for (monthName of locale.monthNames; track j; let j = $index) {
                      <option [selected]="j === month.month" [value]="j">
                        {{ monthName }}
                      </option>
                    }
                  </select>
                }
                @if (yearNavigator && numberOfMonths === 1) {
                  <select
                    class="p-datepicker-year"
                    tabindex="-1"
                    (change)="onYearDropdownChange($any($event).target.value)"
                    (click)="$event.stopPropagation()">
                    @for (year of yearOptions; track $index) {
                      <option [selected]="year === currentYear" [value]="year">
                        {{ year }}
                      </option>
                    }
                  </select>
                }
                @if (!yearNavigator) {
                  <span class="p-datepicker-year" (click)="switchToYearView($event)">{{ currentView === 'month' ? currentYear : month.year }}</span>
                }
              </div>
            </div>
            @if (currentView === 'date') {
              <div class="p-datepicker-calendar-container">
                <table aria-label="datepicker calendar table" class="p-datepicker-calendar">
                  <thead>
                    <tr>
                      @for (weekDay of weekDays; track $index; let begin = $first; let end = $last) {
                        <th scope="col">
                          <span>{{ weekDay }}</span>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (week of month.dates; track $index) {
                      <tr>
                        @for (date of $any(week); track $index) {
                          <td
                            [ngClass]="[
                              date.otherMonth ? 'p-datepicker-other-month' : '',
                              isSelected(date) ? 'p-datepicker-current-day' : '',
                              date.today ? 'p-datepicker-today' : '',
                            ]">
                            @if (date.otherMonth ? showOtherMonths : true) {
                              @if (date.selectable) {
                                <a
                                  draggable="false"
                                  tabindex="-1"
                                  [ngClass]="[isSelected(date) ? 'p-highlight' : '', date.today ? 'p-highlight' : '']"
                                  (click)="onDateSelect($event, date)">
                                  @if (!dateTemplate) {
                                    {{ date.day }}
                                  } @else {
                                    <ng-container
                                      [ngTemplateOutlet]="dateTemplate"
                                      [ngTemplateOutletContext]="{ $implicit: date }" />
                                  }
                                </a>
                              } @else {
                                <span class="p-disabled"> {{ date.day }} </span>
                              }
                            }
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        }
        @if (currentView === 'month') {
          <div class="p-monthpicker">
            @for (m of monthPickerValues(); track i; let i = $index) {
              <a
                href="#"
                tabindex="-1"
                [ngClass]="[isMonthSelected(i) ? 'p-highlight' : '', 'p-monthpicker-month']"
                (click)="onMonthSelect($event, i)">
                {{ m }}
              </a>
            }
          </div>
        }
        @if (currentView === 'year') {
          <div class="p-yearpicker">
            @for (y of yearPickerValues(); track y) {
              <a
                href="#"
                tabindex="-1"
                [ngClass]="[isYearSelected(y) ? 'p-highlight' : '', 'p-yearpicker-year']"
                (click)="onYearSelect($event, y)">
                {{ y }}
              </a>
            }
          </div>
        }
      }

      @if (showTime || timeOnly) {
        <div class="p-timepicker ui-corner-all">
          <div class="p-hour-picker">
            <a
              tabindex="-1"
              (click)="$event.stopPropagation()"
              (mousedown)="onTimePickerElementMouseDown($event, 0, 1)"
              (mouseup)="onTimePickerElementMouseUp($event)">
              <span class="pi pi-chevron-up"></span>
            </a>
            <span [ngStyle]="{ display: currentHour < 10 ? 'inline' : 'none' }">0</span>
            <span>{{ currentHour }}</span>
            <a
              tabindex="-1"
              (click)="$event.stopPropagation()"
              (mousedown)="onTimePickerElementMouseDown($event, 0, -1)"
              (mouseup)="onTimePickerElementMouseUp($event)">
              <span class="pi pi-chevron-down"></span>
            </a>
          </div>
          <div class="p-separator">
            <a tabindex="-1" (click)="$event.stopPropagation()">
              <span class="pi pi-chevron-up"></span>
            </a>
            <span>{{ timeSeparator }}</span>
            <a tabindex="-1" (click)="$event.stopPropagation()">
              <span class="pi pi-chevron-down"></span>
            </a>
          </div>
          <div class="p-minute-picker">
            <a
              tabindex="-1"
              (click)="$event.stopPropagation()"
              (mousedown)="onTimePickerElementMouseDown($event, 1, 1)"
              (mouseup)="onTimePickerElementMouseUp($event)">
              <span class="pi pi-chevron-up"></span>
            </a>
            <span [ngStyle]="{ display: currentMinute < 10 ? 'inline' : 'none' }">0</span>
            <span>{{ currentMinute }}</span>
            <a
              tabindex="-1"
              (click)="$event.stopPropagation()"
              (mousedown)="onTimePickerElementMouseDown($event, 1, -1)"
              (mouseup)="onTimePickerElementMouseUp($event)">
              <span class="pi pi-chevron-down"></span>
            </a>
          </div>
          @if (showSeconds) {
            <div class="p-separator">
              <a tabindex="-1" (click)="$event.stopPropagation()">
                <span class="pi pi-chevron-up"></span>
              </a>
              <span>{{ timeSeparator }}</span>
              <a tabindex="-1" (click)="$event.stopPropagation()">
                <span class="pi pi-chevron-down"></span>
              </a>
            </div>
            <div class="p-second-picker">
              <a
                tabindex="-1"
                (click)="$event.stopPropagation()"
                (mousedown)="onTimePickerElementMouseDown($event, 2, 1)"
                (mouseup)="onTimePickerElementMouseUp($event)">
                <span class="pi pi-chevron-up"></span>
              </a>
              <span [ngStyle]="{ display: currentSecond < 10 ? 'inline' : 'none' }">0</span>
              <span>{{ currentSecond }}</span>
              <a
                tabindex="-1"
                (click)="$event.stopPropagation()"
                (mousedown)="onTimePickerElementMouseDown($event, 2, -1)"
                (mouseup)="onTimePickerElementMouseUp($event)">
                <span class="pi pi-chevron-down"></span>
              </a>
            </div>
          }
          @if (hourFormat === '12') {
            <div class="p-ampm-picker">
              <a tabindex="-1" (click)="toggleAMPM($event); $event.stopPropagation()">
                <span class="pi pi-chevron-up"></span>
              </a>
              <span>{{ pm ? 'PM' : 'AM' }}</span>
              <a tabindex="-1" (click)="toggleAMPM($event); $event.stopPropagation()">
                <span class="pi pi-chevron-down"></span>
              </a>
            </div>
          }
        </div>
      }
      @if (showButtonBar) {
        <div class="p-datepicker-buttonbar">
          <div class="p-grid">
            <div class="p-col-6">
              <button
                pButton
                style="width: 100%"
                tabindex="-1"
                type="button"
                [label]="_locale.today"
                [ngClass]="[todayButtonStyleClass || '', 'p-button-primary']"
                (click)="onTodayButtonClick($event)"></button>
            </div>
            <div class="p-col-6">
              <button
                pButton
                style="width: 100%"
                tabindex="-1"
                type="button"
                [label]="_locale.clear"
                [ngClass]="[clearButtonStyleClass || '', 'p-button-alert']"
                (click)="onClearButtonClick($event)"></button>
            </div>
            @if (showTime || timeOnly) {
              <div class="p-col-6">
                <button
                  pButton
                  style="width: 100%"
                  tabindex="-1"
                  type="button"
                  [label]="'OK'"
                  [ngClass]="[todayButtonStyleClass || '', 'p-button-info']"
                  (click)="onOKButtonClick($event)"></button>
              </div>
            }
          </div>
        </div>
      }
      <ng-content select="p-footer" />
    </div>
  }
</span>

<ng-template #todayModeSuggestionsTpl let-suggestions>
  @if (suggestions.length > 0) {
    <div class="p-calendar-today-suggestions">
      @for (suggestion of suggestions; track $index) {
        <a class="p-calendar-today-suggestions-item" tabindex="-1" (click)="onSuggestionClick($event, suggestion)">
          {{ suggestion }}
        </a>
      }
    </div>
  }
</ng-template>
